// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { BillingQueries } from '../../../../types/server/modules/billing/queries';

export type * from '../../../../types/server/modules/billing/queries';

export const createQueries = ( requests: Requests ): BillingQueries => ({
  BillingProductsById: ( id, query, headers ) => { 
          return requests.get( `/billing/products/${id}`, query, headers ); 
        },
  BillingProducts: ( params?, headers? ) => {
        return requests.get( `/billing/products/:id?`, params, headers );
      },
  BillingUsageAggregate: ( params?, headers? ) => {
        return requests.get( `/billing/usage/aggregate`, params, headers );
      },
  BillingUsageSales: ( params?, headers? ) => {
        return requests.get( `/billing/usage/sales`, params, headers );
      },
  BillingUsagePublications: ( params?, headers? ) => {
        return requests.get( `/billing/usage/publications`, params, headers );
      }
});
